import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { examEditCancel, examCreate, examEdit, examLoad } from '../../../redux/actions/exam/examActions';
import { appointmentLoad } from '../../../redux/actions/appointmentActions';
import { patientMedicalHistoriesLoad } from '../../../redux/actions/patient/patientMedicalHistoryActions';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import NewExamForm from '../exam/NewExamForm';
import { ModalFormWrapper } from '../../../itrust_common/components/others'
import { handleStartExamRecording } from '../exam/CommonFunctions';
import { onBoardingTourInfoReset } from '../../../redux/actions/onBoardingActions';
import { useEffect } from 'react';

function CreateExamModal(props) {
  const { examEditing, saving, activeTourType } = props;
  const dispatch = useDispatch()

  useEffect(() => {
    if (!examEditing) {
      $('#newExamForm-modal').modal('hide');
    }
  }, [examEditing])

  const handleExamEditCancel = () => {
    if (activeTourType === 'create_exam') {
      dispatch(onBoardingTourInfoReset())
    }
    dispatch(examEditCancel());
    $('#newExamForm-modal').modal('hide');
  }

  const handleExamSubmit = async (data) => {
    if (activeTourType === 'create_exam') {
      handleExamOnboardingTour()
    }
    let res = await dispatch(examCreate(data, { include: '*' }))
    handleAppointmentLoad()
    handleExamOpenLoad(res)
    $('#newExamForm-modal').modal('hide');
    $('#editExamForm-modal').modal('show');
  }

  const handleExamOpenLoad = async (res) => {
    // Open exam Edit model just after creation
    let id = res.value.data.exam.id
    dispatch(examEdit(id));
    dispatch(examLoad(id, { include: '*' }))
      .then((response) => {
        var res = response.value.data.exam
        //Medical history for overview
        res.is_telemed && handleStartExamRecording()
        dispatch(patientMedicalHistoriesLoad(res.patient_id, { rpp: 500 }));
        //Prescription report template
        dispatch(patientReportsLoad({ patient_id: res.patient_id, staff_id: res.staff_id, store_id: res.store_id, filter: { category: ["medical_rx", "referral"] } }))
      })
  }

  const handleAppointmentLoad = () => {
    //Load appointment if exam created from appointment
    if (examEditing && examEditing.data && examEditing.data.appointmentId)
      dispatch(appointmentLoad(examEditing.data.appointmentId, { include: ['patient', 'staff', 'procedures', 'examination', 'order'] }))
  }

  const handleExamOnboardingTour = () => {
    $('#newExamForm-modal').modal('hide');
    dispatch(onBoardingTourInfoReset(activeTourType))
  }

  return (
    <ModalFormWrapper
      formName={`newExamForm`}
      saving={saving}
      formTitle="New Exam"
      label='Create Exam'
      handleEditCancel={handleExamEditCancel}
    >
      {examEditing.id == 'New' &&
        <NewExamForm
          onSubmit={handleExamSubmit}
        />
      }
    </ModalFormWrapper>
  )
}

function mapStateToProps(state) {
  const { exam, patient, currentStore, onBoarding } = state;
  return {
    examEditing: exam.editing,
    saving: exam.saving,
    patient: patient.patient,
    store: currentStore.store,
    activeTourType: onBoarding.activeTourType,
  };
}

export default connect(mapStateToProps)(CreateExamModal);